import { useMemo, useState } from 'react';
export function useBKJComboBoxContextHooks() {
    const [inputValue, setInputValue] = useState('');
    const [anchorElement, setAnchorElement] = useState();
    const [dropdownElement, setDropdownElement] = useState();
    const values = useMemo(() => ({ inputValue, anchorElement, dropdownElement }), [anchorElement, dropdownElement, inputValue]);
    const setMethods = useMemo(() => ({ setInputValue, setAnchorElement, setDropdownElement }), []);
    return [values, setMethods];
}
//# sourceMappingURL=BKJComboBox.context.hooks.js.map